<template>
  <div class="page_xftAbnormal">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="异常类型" size="small">
              <el-select v-model="listQuery.exType" placeholder="" clearable filterable style="width:180px">
                <el-option label="默认" value="0"></el-option>
                <el-option label="薪福通未作废" value="1"></el-option>
                <el-option label="薪福通丢失" value="3"></el-option>
                <el-option label="数字化丢失" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否处理" size="small">
              <el-select v-model="listQuery.optionType" clearable placeholder="" filterable style="width:180px">
                <el-option label="默认" value="0"></el-option>
                <el-option label="未处理" value="1"></el-option>
                <el-option label="已处理" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.projectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <div>
            <el-form-item label="客服申报月" size="small" label-width="128px">
              <el-date-picker v-model="listQuery.attrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="薪福通批次号" size="small">
              <el-input v-model="listQuery.batPid" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.Operator" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
          </div>
          <div style="margin-top:5px">
            <el-form-item label="开始时间" size="small" label-width="128px">
              <el-date-picker v-model="listQuery.beginTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" size="small">
              <el-date-picker v-model="listQuery.endTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="税款所属期" size="small">
              <el-date-picker v-model="listQuery.incomeTaxMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- <div>
            <el-form-item label="服务部门" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>薪福通异常</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small">导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="IncomeTaxMonth" label="税款所属期" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="AttrMonth" label="客户申报月" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ExType" label="异常类型" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.ExType==0 ? '默认' : row.ExType==1 ? '薪福通未作废' : row.ExType==2 ? '数字化丢失' : '薪福通丢失'}}</template>
          </el-table-column>
          <el-table-column prop="ExTime" label="发生时间" min-width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.ExTime ? row.ExTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="ExOptionTime" label="异常处理时间" min-width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.ExOptionTime ? row.ExOptionTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="OptionType" label="处理情况" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.OptionType==0 ? '默认' : row.ExType==1 ? '未处理' : '已处理'}}</template>
          </el-table-column>
          <el-table-column prop="ProcessState" label="来源" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark" label="备注" min-width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="300" align="center" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-popconfirm title="请确认系统修改此条异常处理状态为“未处理”" @confirm="signHandel(row,'1')" v-if="row.optionType==2" style="margin:0 10px;">
                  <el-button type="text" slot="reference">登记未处理</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确认系统修改此条异常处理状态为“已处理”" @confirm="signHandel(row,'1')" v-if="row.optionType==1" style="margin:0 10px;">
                  <el-button type="text" slot="reference">登记已处理</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确认从薪福通系统拷贝本批次算税数据进数字化系统" @confirm="RecoverSys(row)" v-if="row.optionType!=2 && row.ExType==2" style="margin:0 10px;">
                  <el-button type="text" slot="reference">拷贝到数字化</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确认在薪福通系统作废此算税批次" @confirm="del" v-if="row.optionType!=2 && row.ExType==1" style="margin:0 10px;">
                  <el-button type="text" slot="reference">薪福通作废</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确认在薪福通系统重新算税，恢复薪福通数据" v-if="
                row.optionType!=2 && row.ExType==3"
                @confirm="RecoverXft(row)" style="margin:0 10px;">
                  <el-button type="text" slot="reference">薪福通重算</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          exType: '', //（0=默认，1=薪福通未作废，2=数字化丢失，3=XftLost）
          optionType: '', //（0=默认，1=未处理，2=已处理）
          projectName: '',
          incomeTaxMonth: '', //税款所属期
          attrMonth: '', //客户申报月
          batPid: '', //批次号
          Operator: '', //客服姓名
          beginTime: '',
          endTime: '',
          pageNum: 1,
          pageSize: 10,
        },
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        multipleSelection: [],
        setForm: {
          date: '',
          time: '',
          aaa: '',
        }
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      this.getProList();
      this.getList();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      getList() {
        xz.getExList(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data;
            this.totalCount = res.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //登记处理
      signHandel(row, type) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            id: row.Id,
            type
          }
          xz.ExOption(data).then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.$methods.success('保存成功');
              this.getList();
            } else {
              this.loading = false;
              this.$methods.error(res.msg);
            }
          })
        }
      },
      //拷贝到数字化
      RecoverSys(row) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            id: row.Id
          }
          xz.RecoverSys(data).then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.$methods.success('保存成功');
              this.getList();
            } else {
              this.loading = false;
              this.$methods.error(res.msg);
            }
          })
        }
      },
      //薪福通重算
      RecoverXft(row) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            id: row.Id
          }
          xz.RecoverXft(data).then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.$methods.success('保存成功');
              this.getList();
            } else {
              this.loading = false;
              this.$methods.error(res.msg);
            }
          })
        }
      },
      del(row) {
        if (!this.loading) {
          this.loading = true;
          xz.cancellApplication(row.Id, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.getList();
              this.$message.success('作废成功！')
            } else {
              this.loading = false;
              this.getList();
              this.$message.error(res.msg);
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }
</style>
<style>
  .page_xftAbnormal .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_xftAbnormal .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_xftAbnormal .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_xftAbnormal .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_xftAbnormal .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_xftAbnormal .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>